import { useEffect, useState } from 'react'

import { getFlats } from '../../../api'
import { EMPTY_OBJECT } from '../../../constants/common'
import { PAGINATION_ALL_ITEMS_SIZE } from '../../../constants/pagination'
import { SIZE } from '../../../constants/size'
import { useNotification } from '../../../hooks'
import { toFlatSelectItems, toFlatWithBuildingSelectItem } from '../../Flat'
import { FormModal } from '../../Form'
import { useResizeModal } from '../../Modal'

import {
  QA_NAME_EDIT_ADDRESS,
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS,
  USER_EDIT_ADDRESS_FORM_MODAL_INITIAL_VALUES,
} from './UserEditAddressFormModal.constants'
import {
  getUserEditAddressFormModalInitialValues,
  getUserEditAddressFormModalSaveConfirmCondition,
  getUserEditAddressFormModalSubmitPayload,
  getUserEditAddressFormModalValidationSchema,
} from './UserEditAddressFormModal.utils'
import { UserEditAddressFormModalFields } from './UserEditAddressFormModalFields'

import * as styles from './UserEditAddressFormModal.module.css'

function UserEditAddressFormModal({
  ownerId,
  permissions,
  onArchive,
  onClose,
  onSubmit,
}) {
  const { handleAddErrorNotification } = useNotification()

  const [initialValues, setInitialValues] = useState(
    getUserEditAddressFormModalInitialValues(
      USER_EDIT_ADDRESS_FORM_MODAL_INITIAL_VALUES
    )
  )
  const [isLoading, setLoading] = useState(true)
  const [flatsPermissions, setFlatsPermissions] = useState(EMPTY_OBJECT)

  const validationSchema = getUserEditAddressFormModalValidationSchema({
    initialValues,
  })

  const { fullScreen, handleResizeModal } = useResizeModal()

  useEffect(() => {
    getFlats({
      inhabitant: ownerId,
      size: PAGINATION_ALL_ITEMS_SIZE,
    })
      .then(({ data }) => {
        setInitialValues(prev => ({
          ...prev,
          [USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS]:
            toFlatSelectItems(data.items, toFlatWithBuildingSelectItem),
        }))
        setFlatsPermissions(data.permissions)
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  function getSaveConfirmCondition(values) {
    // The T&L list rows carry no per-row permissions, so callers that cannot
    // provide profile permissions fall back to the flat-options response ones.
    return getUserEditAddressFormModalSaveConfirmCondition(
      values,
      permissions ?? flatsPermissions
    )
  }

  function handleSubmit({ value }) {
    onSubmit(value)
  }

  return (
    <FormModal
      saveConfirm
      Fields={UserEditAddressFormModalFields}
      containerProps={{
        boxSize: SIZE.LARGE,
        isFullScreen: fullScreen,
        qaName: QA_NAME_EDIT_ADDRESS,
        onResize: handleResizeModal,
      }}
      formBodyProps={{
        contentClassName: styles.content,
        contentProps: {
          contentWrapperClassName: styles.contentWrapper,
          isFullScreen: fullScreen,
          size: SIZE.LARGE,
        },
        withNotifications: true,
      }}
      formFieldsProps={{
        isLoading,
      }}
      formTitle='Modal.ChangeBuildingTitleKey'
      getPayload={getUserEditAddressFormModalSubmitPayload}
      getSaveConfirmCondition={getSaveConfirmCondition}
      initialValues={initialValues}
      saveConfirmationProps={{
        actionButtonsProps: {
          cancelText: 'Modal.CancelBtnKey',
          submitText: 'Modal.SaveBtnKey',
        },
        description: 'Modal.TenantWithoutFlatConfirmationTextKey',
        onSubmit: onArchive,
      }}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default UserEditAddressFormModal
